import { TranslateFunc } from 'ha/i18n';
import { Kinds, TypesTranslations, KindsTranslations } from 'ha/constants/Room';

interface Props {
  T: TranslateFunc;
  kind: number;
  type: number;
  bedroomCount: string;
}

export default function getListingPreviewTitle({
  T,
  kind,
  type,
  bedroomCount,
}: Props) {
  if (kind === Kinds.EntirePlace && bedroomCount === '0') {
    return T('Studio');
  }

  switch (kind) {
    case Kinds.EntirePlace:
      return T(TypesTranslations[type]);
    case Kinds.PrivateRoom:
      return T(KindsTranslations[Kinds.PrivateRoom]);
    case Kinds.SharedRoom:
      return T(KindsTranslations[Kinds.SharedRoom]);
    default:
      return T('Room');
  }
}
